import { render, staticRenderFns } from "./BookBasicSteps.vue?vue&type=template&id=247a8ad0&scoped=true&"
import script from "./BookBasicSteps.vue?vue&type=script&lang=js&"
export * from "./BookBasicSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247a8ad0",
  null
  
)

export default component.exports